import { ifwLogo } from './ifwlogobase64';

const PdfHeader = (props) => {
    return (

        <div
            style={{
                marginTop: '-85px',
                background: 'linear-gradient(180deg, rgba(213,251,243,1) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%)',
                display: 'flex',
                flexDirection: 'row',
                position: 'relative',
                ...props.style,
            }}>
            <img
                style={{ height: '100px' }}
                src={ifwLogo}
                title={"IFW"}
                alt={"IFW"}
            />
        </div>

    )
}

export default PdfHeader
